var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuzzEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45.00073,
    viewBox: "0 0 45 45.00073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.8006,44.94862l11.69572-3.20072c.24009-.06448.45685-.1907.62972-.36493l28.69945-28.68573c2.90026-2.90164,2.89889-7.62246-.00137-10.52409-1.45013-1.44876-3.35575-2.17314-5.26136-2.17314s-3.81123.72438-5.26136,2.17314L3.60743,30.8575c-.17561.17561-.3032.39512-.36905.63658L.05001,43.19392c-.13445.4939.00686,1.02483.36768,1.38565.36219.36082.89724.50899,1.38291.36905Zm4.09659-12.33779L34.32088,4.19537c1.789-1.79037,4.69612-1.78763,6.48238-.00137,1.78626,1.78763,1.78626,4.69475.00137,6.48238l-28.42781,28.41546-8.91207,2.4393,2.43244-8.9203Z",
    fill: "#333",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuzzEdit);
export default __webpack_public_path__ + "static/media/buzz-edit.661d1fcd546c2d5ba2ba45570d205809.svg";
export { ForwardRef as ReactComponent };